import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackScreenView } from "@/lib/analytics";

export function useScreenTracking() {
  const location = useLocation();

  useEffect(() => {
    trackScreenView(location.pathname);
  }, [location.pathname]);
}
